import { render, staticRenderFns } from "./ShoppingCartIcon.vue?vue&type=template&id=856b6ab6&scoped=true&"
import script from "./ShoppingCartIcon.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartIcon.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartIcon.vue?vue&type=style&index=0&id=856b6ab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856b6ab6",
  null
  
)

export default component.exports